import { reactive } from "vue";

export const store = reactive({
    formData: {
        standards: [],
        standardTotal: {},
        standardsAnnualSummary: { },
        savings: {},
        savingsTotal: {},
        user: {}
    },
    initialiseFormData(workingData) {
        this.formData = workingData;
    },
    formState: {
        page: 'home',
        modal: 'disclaimer',
        awaitingSavingCalc: false,
        addSavingType: ''
    },
    closeModal() {
        this.formState.modal = false;
    },
    resetSavingType() {
        this.formState.addSavingType = '';
    }
});